export default {
  notRecaluatePrompts: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000B7","正在计算中，请勿重复操作...") /* "正在计算中，请勿重复操作..." */,
  calculateBegin: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000B8","计算开始") /* "计算开始" */,
  calculateFinish: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000B9","计算完成!") /* "计算完成!" */,
  firstTimePrompts: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000BA","请点计算按钮，获取最新的信用信息!") /* "请点计算按钮，获取最新的信用信息!" */,
  calculateFinishPrompts: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000BB","请到相应的页面查看执行结果!") /* "请到相应的页面查看执行结果!" */
};
